var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFacebookContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 11C7.16263 11.5811 5.13956 39.417 24.4871 43H29.5128C48.8647 39.4136 46.8329 11.579 26.9999 11Z",
    fill: "#F96619"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5127 31.7508H33.2601L33.9732 27.0977H29.5127V24.0779C29.5127 22.805 30.1359 21.5641 32.1337 21.5641H34.1618V17.6025C29.8186 16.82 24.6006 17.0581 24.487 23.5511V27.0977H20.4035V31.7508H24.487V43H29.5127V31.7508Z",
    fill: "#F1F1F1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacebookContact);
export default __webpack_public_path__ + "static/media/ic_facebook_contact.32ab552311474107639f781821ffcbf1.svg";
export { ForwardRef as ReactComponent };